import customersGroups from './customersGroups';
import customers from './customers';
export default {
    customersGroups,
    customers,
}